import { usePatientHistoryQuery } from '@common/cache';
import { useState } from 'react';
import { useDrawerStore } from '@store';

export const usePatientHistory = (patient_id: string, isTabOpen: boolean) => {
  const { setDrawerOpen, setTaskId } = useDrawerStore(state => state);

  const [historyPage, setHistoryPage] = useState(1);

  const handleOpenTaskDetails = (id: string) => {
    setDrawerOpen(true);
    setTaskId(id);
  };

  const {
    data = {
      history: [],
      count: 0,
    },
    isLoading,
  } = usePatientHistoryQuery({
    patient_id,
    limit: 10,
    page: historyPage,
    enabled: isTabOpen,
  });

  return {
    historyList: data.history,
    count: data.count,
    setHistoryPage,
    historyPage,
    handleOpenTaskDetails,
    isLoading,
  };
};
